import { render } from "./SsoCallback.vue?vue&type=template&id=6f37c132&scoped=true"
import script from "./SsoCallback.vue?vue&type=script&lang=js"
export * from "./SsoCallback.vue?vue&type=script&lang=js"

import "./SsoCallback.vue?vue&type=style&index=0&id=6f37c132&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f37c132"]])

export default __exports__